import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import HeroBannerSlider from '../components/HeroBannerSlider';
import PromoBanner from '../components/PromoBanner';
import BestSellersSection from '../components/BestSellersSection';

const Home = () => {
  return (
    <main className="bg-[#f5f1e6] text-[#1a1410]">
      <HeroBannerSlider />

      <BestSellersSection />

      <PromoBanner />

      <section className="bg-[#ece4d2] px-6 lg:px-10 py-24">
        <div className="max-w-3xl">
          <div className="text-[11px] tracking-[0.28em] text-[#3a2e26] border-t border-[#1a1410] pt-3 inline-block">THE RITUAL BEGINS</div>
          <h2 className="font-serif text-[44px] lg:text-[56px] leading-[1.05] mt-6">
            Find your shade<br />
            <span className="italic">in ninety seconds.</span>
          </h2>
          <p className="mt-8 max-w-xl text-[16px] leading-[1.8] text-[#3a2e26]">
            Four considered questions. Your skin, your undertone, your finish, your mood. We compose a personal edit of three shades — made just for you.
          </p>
          <Link to="/quiz" className="mt-10 inline-flex items-center gap-3 bg-[#1a1410] text-[#f5f1e6] px-8 py-4 text-[11px] tracking-[0.32em] hover:bg-black transition-colors">
            BEGIN THE QUIZ
            <ArrowRight className="w-4 h-4" strokeWidth={1.4} />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Home;
